module.exports = __webpack_public_path__ + "static/media/wifi-level-3.492072de.svg";